module.exports = __webpack_public_path__ + "img/bar-code.63470bba.svg";